import styled from "styled-components";
import { bodyColor } from "../../../../../../../../config/constants";
import { inputCheckboxIndex } from "../../../../../../../../config/zIndex";

// Styles
export const PrescriptionDiv = styled.div`
  margin: 0 16px 4px;
  width: fit-content;
  max-width: 860px;
  height: 40px;
  display: flex;
  border-radius: 5px;
  border: ${({ border }) => border && border};
  align-items: center;
  background-color: ${({ background }) => background && background};
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  position: relative;
`;
export const ProtocolCardDiv = styled.div`
  width: 290px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px;
`;
export const VideoButton = styled.button`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  border: none;
  border-radius: 5px;
  background: transparent;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const ProtocolImgDiv = styled.div`
  margin-right: 15px;
  width: 80px;
  height: ${({ height }) => height && height};
  position: relative;
`;
export const ProtocolImg = styled.img`
  width: 80px;
  height: 100%;
`;
export const VideoButtonImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const InfoImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const ProtocolName = styled.p`
  margin-left: 15px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: left;
`;
export const PrescriptionDaysDiv = styled.div`
  width: 190px;
`;
export const PrescriptionDaysAligner = styled.div`
  width: 180px;
  display: flex;
  border: 40px;
  gap: 2px;
`;
export const InputCheckboxDiv = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: ${({ borderRadius }) => borderRadius && borderRadius};
  background-color: ${({ background }) => background && background};
`;
export const InputCheckbox = styled.input`
  width: 24px;
  height: 24px;
  opacity: 0;
  position: absolute;
  z-index: ${inputCheckboxIndex};
  cursor: pointer;
`;
export const DayText = styled.p`
  font-size: 12px;
  color: ${({ color }) => color && color};
`;
export const FunctionsDiv = styled.div`
  width: 140px;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 5px;
`;
export const FunctionDiv = styled.div`
  padding: 2px 8px;
  text-align: center;
  border-radius: 100px;
  background-color: ${({ background }) => background && background};
`;
export const FunctionText = styled.p`
  font-size: 10px;
  font-weight: 600;
  color: ${({ color }) => color && color};
`;
export const DurationDiv = styled.div`
  width: 72px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DurationSelect = styled.select`
  width: 80%;
  height: 30px;
  font-size: 14px;
  color: #000;
  border: 1px solid ${bodyColor};
  border-radius: 5px;
  appearance: none;
  outline: none;
  text-align: center;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
